import React from 'react';
import {Control, FieldValues, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {translationNamespaces} from '@/common/enums';
import Input from '@/components/Form/Input/Input';
import Button from '@/components/Registration/Button';
import RegistrationWrapper from '@/components/Registration/Wrapper';

import styles from '../Registration.module.scss';
import {getEmailRules} from '../RegistrationHelpers';

export type TForgotPasswordInputs = {
  email: string;
};

export type TForgotPassword = {
  onSubmit: (data: TForgotPasswordInputs) => Promise<void>;
  isLoading?: boolean;
  isSent?: boolean;
  error?: string;
};

const ForgotPassword = ({
  onSubmit,
  isLoading = false,
  isSent,
  error,
}: TForgotPassword): JSX.Element | null => {
  const {t} = useTranslation(translationNamespaces.REGISTRATION);
  const {t: tGlobal} = useTranslation(translationNamespaces.GLOBAL);
  const {control, handleSubmit, formState} = useForm<TForgotPasswordInputs>({
    mode: 'onTouched',
  });

  return (
    <RegistrationWrapper
      heading={t('forgotPassword.heading')}
      description={t('forgotPassword.description')}
      error={error}
      success={isSent ? t('forgotPassword.sent') : undefined}
    >
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <Input
          type='email'
          name='email'
          label={tGlobal('EMAIL')}
          className={styles.input}
          control={control as Control<FieldValues>}
          rules={getEmailRules(t)}
          error={formState.errors.email}
        />

        <Button isLoading={isLoading} label={t('forgotPassword.submit')} />
      </form>
    </RegistrationWrapper>
  );
};

export default ForgotPassword;
